import { Link } from 'gatsby';
import styled from '@emotion/styled';
import { ArrowIcon } from '@components/Svg';

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const LinksWrapper = styled.div`
  display: flex;
  max-width: 720px;
  margin: 70px 50px 0 50px;

  @media (max-width: ${(props) => props.theme.breakpoints.s}) {
    flex-direction: column;
    width: 90%;
  }
`;

export const PageLink = styled(Link)`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: ${(props) =>
    props.navType == 'next' ? 'flex-start' : 'flex-end'};
  padding: ${(props) =>
    props.navType == 'next' ? '0 0 0 60px' : '0 60px 0 0'};
  cursor: pointer;

  h1,
  p {
    text-align: ${(props) => (props.navType == 'next' ? 'left' : 'right')};
  }

  &:hover {
    h1 {
      color: ${(props) => props.theme.colors.primary.base};
    }
    svg {
      fill: ${(props) => props.theme.colors.primary.base};
    }
  }

  @media (max-width: ${(props) => props.theme.breakpoints.s}) {
    align-items: center;
    text-align: center;
    padding: 0;
    margin-top: ${(props) => (props.navType == 'next' ? '40px' : 0)};

    h1,
    p {
      text-align: center;
    }
  }
`;

export const Title = styled.h1`
  font-size: 50px;
  margin-bottom: 20px;
  color: ${(props) => props.theme.colors.black.base};
`;
export const Overview = styled.p`
  font-size: 15px;
  color: ${(props) => props.theme.colors.black.base};
  line-height: 18px;
  min-height: 150px;
  @media (max-width: ${(props) => props.theme.breakpoints.s}) {
    min-height: 90px;
  }
  margin: 0;
`;

export const Arrow = styled(ArrowIcon)`
  width: 110px;
  padding: 30px;

  @media (max-width: ${(props) => props.theme.breakpoints.s}) {
    margin: 0;
  }
`;
